import styled from '@emotion/styled';
import { Typography } from '@mui/material';

// StepTitle
export const StepTitle = styled(Typography)`
  text-align: center;
  font-weight: lighter;
`;
